/*
 Created by qing 2019/12/26 5:46 下午
 */
import {
  FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__MULTILINE,
  FORM_ITEM__NUMBER,
  FORM_ITEM__CURRENCY,
  FORM_ITEM__SERIAL_NUMBER,
  FORM_ITEM__DESCRIPTION,
  FORM_ITEM__SINGLE_CHOOSE,
  FORM_ITEM__CHECKBOX,
  FORM_ITEM__DROPDOWN,
  FORM_ITEM__RTF,
  FORM_ITEM__DATE,
  FORM_ITEM__DATE_RANGE,
  FORM_ITEM__IMAGE,
  FORM_ITEM__ATTACHMENT,
  FORM_ITEM__GRADE,
  FORM_ITEM__IMAGE_CHOOSE,
  FORM_ITEM__SLIDING_BLOCK,
  FORM_ITEM__YES_NO,
  FORM_ITEM__ADDRESS,
  FORM_ITEM__MEMBER,
  FORM_ITEM__DEPARTMENT,
  FORM_ITEM__TABLE,
  FORM_ITEM__SUMMARY,
  FORM_ITEM__EXTERNAL_DATA_SOURCE,
  FORM_ITEM__PHONE
} from "../RyForm/types"

class RyViewSet {

  constructor() {
    this.userId = ""
    this.companyId = ""
    this.appId = ""
    this.formId = "" // 表单Id
    this.viewId = ""
    this.viewType = "" // DATA_VIEW 数据视图 BOARD_VIEW 看板视图
    //共有属性
    this.viewName = "" // 视图名称
    this.hiddenFieldList = [] // 隐藏字段
    this.partHiddenFieldList = [] // 字段内容部分隐藏列表
    this.allowExport = 1 //是否允许导出数据
    this.allowImport = 'NO'
    this.allowCopy = 'YES'
    this.allowBatchPrint = 1 //是否允许批量打印
    this.allowEditMobileStyle = 1 //是否允许修改移动端样式
    this.sortList = [
      {
        fieldId: "updateTime",
        sortType: -1 // -1 降序 1 正序、、 -1：Z-A  1:A-Z 、、 -1最新在前， 1最旧在前
      }
    ] //排序字段
    this.hiddenFilter = 0 // 是否异常筛选按钮
    this.filter = {
      relation: 'and',
      jumpEmpty: 0,
      conditionList: [
        /*
        {
          "type":"number", //控件的类型
          "method":"eq", //匹配的方法
          "fixedValue":"MIDDLE", //MIDDLE  中间变量
          "value":[  //匹配的值
            25
          ],
          "fieldId":"控件的Id", //当时子表单的控件时 需要为"tableFiledId.subFiledId"
          "localFieldId":"中间变量 Id"
        }
        */
      ]
    } // 筛选条件
    this.visibleUserList = {
      depart: [], // 部门
      member: [], // 成员
      role: [],    // 角色
      external: [],
      externalTag: []
    } // 可见人
    // 看板视图特有属性
    this.groupType = 0 // 0 表单字段 1 自由设置模式
    this.groupFieldId = "" // 分组字段Id
    this.groupList = [] // 分组list，由选择的分组字段生成，或用户自己添加
    this.showFieldList = [] // 卡片显示字段
    this.showTitle = 0 // 设置标题字段 0 否 1 是
    this.cardTitle = "" // 卡片标题fieldId
    this.showFieldTitle = 1 // 显示字段名称 默认勾选 0 否 1 是
    this.showColor = 0 // 设置卡片颜色 0 否 1 是
    this.colorField = "" // 颜色fieldId
    this.showCharge = 0 // 负责人 0 否 1 是
    this.chargeField = "" // 负责人控件fieldId
    this.showDeadline = 0 // 截止时间 0 否 1 是
    this.deadLineField = "" // 截止时间fieldId
    //自定义按钮 事件表单关联
    this.buttonList = []
    this.forbiddenEdit = 0 //禁止修改数据 0 否 1 是

    this.advancedQuery = 0 // 高级筛选开关
    // 高级筛选对象
    this.advanceQueryConfig = {
      middleConfigList: [
        /*
        {
          "middleId": "终边变量的 Id", //前端自己生成
          "middleName": "中间变量的名称",
          "dataSourceConfig": {
            "appId": "",
            "formId": "",
            //不要和原有的使用同一套filetr对象了
            "newFilterInfo": {
              "relation": "and",  //条件之间的关系 and查询 或者 or 查询
              "jumpEmpty": 0,
              "conditionList": [
                {
                  "type": "number", //控件的类型
                  "method": "eq", //匹配的方法
                  "fixedValue": "current_user", //current_user 当前用户 telephone 手机号 userId 用户的 Id
                  "value": [  //匹配的值
                    25
                  ],
                  "fieldId": "控件的Id" //当时子表单的控件时 需要为"tableFiledId.subFiledId" 中间变量的 Id
                }
              ]
            },
            "sortList": [
              {
                "fieldId": "123123123",
                "sortType": -1, //-1 倒序 1 正序
              }
            ], //排序字段
            "resultFieldId": "提取字段 Id",
          }
        }
        */
      ],
      filterInfo: {
        relation: 'and',
        jumpEmpty: 0,
        conditionList: [
          /*
          {
            "type":"number", //控件的类型
            "method":"eq", //匹配的方法
            "fixedValue":"MIDDLE", //MIDDLE  中间变量
            "value":[  //匹配的值
              25
            ],
            "fieldId":"控件的Id", //当时子表单的控件时 需要为"tableFiledId.subFiledId"
            "localFieldId":"中间变量 Id"
          }
          */
        ]
      }
    }

    this.notAllowEditFieldList = [] //不允许修改的字段列表
    this.dataReadOnly = "NO" //视图数据只读 YES 是 NO 否 默认否
    this.showFlowLog = "YES" //显示流程日志
    this.showApproval = "YES" //显示审批意见
    this.showHistory = "YES" //显示历史动态
    this.showComment = "YES" //显示评论

    this.allowDelete = 'NO'

    this.hiddenHeaderFieldList = [] // 隐藏header的字段
    this.freezeColumnCount = 0 // 冻结前几列

    this.viewDetail = "YES" //YES 是 NO 否, 可以点击详情
    this.showFilter = "YES" //筛选条件
    this.openRefresh = "YES" //开启刷新
    this.refreshSecond = 60 //刷新秒数 最小 60s
    this.openPlanLine = "YES" //开启计划线路
    this.planLineConfig = {
      "showPoint": "YES", //是否显示点位
      "dataAppId": '', //数据源的 appId
      "dataFormId": '', // 数据源的 formId
      "groupFieldId": "",
      "groupSortType": "ASC", //ASC 正序 DESC 倒序
      "sortFieldList": [
        {
          "fieldId": "updateTime",
          "sortType": -1, // -1 降序 1 正序、、 -1：Z-A  1:A-Z 、、 -1最新在前， 1最旧在前
        }
      ],
      filterInfo: {
        relation: 'and',
        jumpEmpty: 0,
        conditionList: [
          /*
          {
            "type":"number", //控件的类型
            "method":"eq", //匹配的方法
            "fixedValue":"MIDDLE", //MIDDLE  中间变量
            "value":[  //匹配的值
              25
            ],
            "fieldId":"控件的Id", //当时子表单的控件时 需要为"tableFiledId.subFiledId"
            "localFieldId":"中间变量 Id"
          }
          */
        ]
      }, //数据筛选信息
      "locationFieldId": "",
      "showImageFieldId": ""
    }
    this.realLineConfig = {
      "showPoint": "YES", //是否显示点位
      "dataAppId": '', //数据源的 appId
      "dataFormId": '', //数据源的 formId
      "detailViewId": 'dataHandle', // 查看详情关联的视图
      "groupFieldId": "",
      "groupSortType": "ASC", //ASC 正序 DESC 倒序
      "sortFieldList": [
        {
          "fieldId": "updateTime",
          "sortType": -1, // -1 降序 1 正序、、 -1：Z-A  1:A-Z 、、 -1最新在前， 1最旧在前
        }
      ],
      "filterInfo": {
        relation: 'and',
        jumpEmpty: 0,
        conditionList: [
          /*
          {
            "type":"number", //控件的类型
            "method":"eq", //匹配的方法
            "fixedValue":"MIDDLE", //MIDDLE  中间变量
            "value":[  //匹配的值
              25
            ],
            "fieldId":"控件的Id", //当时子表单的控件时 需要为"tableFiledId.subFiledId"
            "localFieldId":"中间变量 Id"
          }
          */
        ]
      }, //数据筛选信息
      "locationFieldId": "",
      "showImageFieldId": "https://webapi.amap.com/images/car.png"
    }
    this.animationSpeed = 500 // 轨迹回访速度
    //数据卡片信息
    this.cardConfigInfo = {
      "showTitle": 0, //是否显示标题
      "titleFieldId": "", //标题字段
      "showTime": 0, //是否显示时间
      "timeFieldId": "", //时间字段
      "showColor": 0, //是否显示颜色
      "colorFieldId": "", //颜色字段
      "showImage": 0,  //是否显示图片
      "memberShowType": "IMAGE",  //人员字段显示类型 NAME 名字 IMAGE 图像
      "imageFieldId": "", //图片字段
      "showFieldList": [] //详情信息
    }

    this.clickDetail = 'YES' // 气泡图可以点击详情 YES 是 NO 否
    this.openSearch = "YES" // 气泡图筛选条件
    this.dataAppId = '' //
    this.dataFormId = '' //
    this.detailViewId = 'dataHandle' // 查看详情关联的视图
    this.showDistance = "YES" // 显示当前位置距离
    this.locationFieldId = '' // 轨迹定位字段
    this.bubbleContent = '' // 气泡显示信息
    this.openCustomIcon = "NO" //开启个性化图标 YES 是 NO 否
    this.customIconConfigList = [
      // {} //前端对象,后端不解析
    ]
    this.detailShowType = 'DETAIL' // CARD 卡片 DETAIL 详情 NOT 无
    this.detailCardConfig = [] //卡片配置样式,对象数组,后台不解析
    this.showRightList = 'NO' //是否显示右侧列表,默认不显示

    this.dashboardAppId = ''
    this.dashboardId = ''
  }
}

RyViewSet.prototype.groupTypeOpts = [
  {
    label: '表单字段',
    value: 0
  },
  {
    label: '自由设置模式',
    value: 1
  }
]

// 初始化
RyViewSet.init = function ({userId = null, formId = null, companyId = null, appId = null, viewId = null, viewType = 'BOARD_VIEW'} = {}) {
  const viewSet = new RyViewSet()
  viewSet.userId = userId
  viewSet.formId = formId
  viewSet.companyId = companyId
  viewSet.appId = appId
  viewSet.viewId = viewId
  viewSet.viewType = viewType
  return viewSet
}
RyViewSet.prototype.getConf = function () {
  return {
    userId: this.userId,
    companyId: this.companyId,
    appId: this.appId,
    formId: this.formId,
    viewId: this.viewId,
    viewType: this.viewType,
    viewName: this.viewName,
    hiddenFieldList: this.hiddenFieldList,
    partHiddenFieldList: this.partHiddenFieldList,
    allowExport: this.allowExport,
    allowImport: this.allowImport,
    allowCopy: this.allowCopy,
    allowBatchPrint: this.allowBatchPrint,
    allowEditMobileStyle: this.allowEditMobileStyle,
    sortList: this.sortList,
    hiddenFilter: this.hiddenFilter,
    forbiddenEdit: this.forbiddenEdit,
    filter: this.filter,
    visibleUserList: this.visibleUserList,

    groupType: this.groupType,
    groupFieldId: this.groupFieldId,
    groupList: this.groupList,

    showFieldList: this.showFieldList,
    showTitle: this.showTitle,
    cardTitle: this.cardTitle,
    showFieldTitle: this.showFieldTitle,
    showColor: this.showColor,
    colorField: this.colorField,
    showCharge: this.showCharge,
    chargeField: this.chargeField,
    showDeadline: this.showDeadline,
    deadLineField: this.deadLineField,
    buttonList: this.buttonList,

    advancedQuery: this.advancedQuery,
    advanceQueryConfig: this.advanceQueryConfig,
    notAllowEditFieldList: this.notAllowEditFieldList,
    dataReadOnly: this.dataReadOnly,
    showFlowLog: this.showFlowLog,
    showApproval: this.showApproval,
    showHistory: this.showHistory,
    showComment: this.showComment,
    allowDelete: this.allowDelete,

    hiddenHeaderFieldList: this.hiddenHeaderFieldList,
    freezeColumnCount: this.freezeColumnCount,

    viewDetail: this.viewDetail,
    showFilter: this.showFilter,
    openRefresh: this.openRefresh,
    refreshSecond: this.refreshSecond,
    openPlanLine: this.openPlanLine,
    planLineConfig: this.planLineConfig,
    realLineConfig: this.realLineConfig,
    cardConfigInfo: this.cardConfigInfo,
    animationSpeed: this.animationSpeed,

    clickDetail: this.clickDetail,
    openSearch: this.openSearch,
    dataAppId: this.dataAppId,
    dataFormId: this.dataFormId,
    detailViewId: this.detailViewId,
    showDistance: this.showDistance,
    locationFieldId: this.locationFieldId,
    bubbleContent: this.bubbleContent,
    openCustomIcon: this.openCustomIcon,
    customIconConfigList: this.customIconConfigList,
    detailShowType: this.detailShowType,
    detailCardConfig: this.detailCardConfig,
    showRightList: this.showRightList,

    dashboardAppId: this.dashboardAppId,
    dashboardId:this.dashboardId
  }
}
RyViewSet.prototype.setConf = function (opts) {
  Object.keys(opts).forEach(key => {
    if (this.hasOwnProperty(key)) {
      this[key] = opts[key]
    }
  })
}

RyViewSet.prototype.previewCardOpts = {
  [FORM_ITEM__SINGLE_LINE]: '文本字段内容',
  [FORM_ITEM__MULTILINE]: '文本字段内容',
  [FORM_ITEM__SINGLE_CHOOSE]: '单选选项1',
  [FORM_ITEM__DROPDOWN]: '下拉框选项1',
  [FORM_ITEM__SERIAL_NUMBER]: 'apaas-001',
  [FORM_ITEM__EXTERNAL_DATA_SOURCE]: '智能引用文本',
  [FORM_ITEM__PHONE]: '1888888888',
  [FORM_ITEM__NUMBER]: '419',
  [FORM_ITEM__CURRENCY]: '888',
  [FORM_ITEM__YES_NO]: '默认打钩',
  [FORM_ITEM__GRADE]: '100%',
  [FORM_ITEM__SLIDING_BLOCK]: '100%',
  [FORM_ITEM__DATE]: '2019-12-05',
  [FORM_ITEM__CHECKBOX]: '默认打钩',
  [FORM_ITEM__IMAGE]: '轻魔方icon',
  [FORM_ITEM__ATTACHMENT]: '速融.ppt',
  [FORM_ITEM__DATE_RANGE]: '2020-01-01~2021-01-01',
  [FORM_ITEM__ADDRESS]: '北京市海淀区',
  [FORM_ITEM__SUMMARY]: '智能汇总文本字段内容'
}

export default RyViewSet
